import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardActionArea, CardContent, Typography, Chip } from '@mui/material';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const reports = [
  {title:'Финансовые отчеты', text:'Доходы, расходы и прибыль. Периоды, операции, импорт и экспорт.', path:'/reports/financial', Icon:AssessmentOutlinedIcon},
  {title:'Аналитика клиентов', text:'Аренды, выручка и активность клиентов за выбранный период.', path:'/reports/clients', Icon:PeopleOutlineIcon},
  {title:'Отчеты по активам', text:'Загрузка, доходность и окупаемость имущества вашего проката.', path:'/reports/assets', Icon:Inventory2OutlinedIcon},
  {title:'Отчет по продажам', text:'Отдельный отчет по продажам ещё в разработке.', Icon:TrendingUpIcon},
];
export default function Reports() {
  const navigate = useNavigate();
  return <Box className="erp-reports-index">
    <div className="erp-page-heading"><h1>Отчеты</h1><p>Результаты проката в цифрах — от отдельного актива до финансов компании</p></div>
    <div className="erp-report-catalog">{reports.map(({title,text,path,Icon}) => <Card key={title}>
      <CardActionArea disabled={!path} onClick={() => path && navigate(path)} sx={{height:'100%'}}>
        <CardContent sx={{p:3}}><Icon sx={{fontSize:40,color:'primary.main',mb:2}} />
          <Typography variant="h6" gutterBottom>{title}</Typography>
          <Typography color="text.secondary" sx={{mb:3}}>{text}</Typography>
          {path ? <Typography color="primary">Открыть отчет →</Typography> : <Chip label="В разработке" size="small" />}
        </CardContent>
      </CardActionArea>
    </Card>)}</div>
  </Box>;
}
